module.exports = require('./helpers/bundle-url').getBundleURL('9OpHv') + "logo-dark.eefe0b7f.svg";